import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/CookieConsent.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default","GTMNoScript"] */ "/app/src/components/GoogleTagManager.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Toaster"] */ "/app/src/components/ui/toaster.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LanguageProvider"] */ "/app/src/i18n/LanguageContext.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/styles/globals.css");
;
import(/* webpackMode: "eager" */ "/app/src/index.css");
;
import(/* webpackMode: "eager" */ "/app/src/styles/toast.css");
